import React from 'react';
import { useMetaPixel } from './useMetaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problems } from './components/Problems';
import { Audience } from './components/Audience';
import { StatsBanner } from './components/StatsBanner';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { PremiumUpsell } from './components/PremiumUpsell';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useMetaPixel();
  return <div className="w-full min-h-screen bg-cream-bg" data-id="element-0">
      <StickyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <Problems data-id="element-4" />
      <Audience data-id="element-5" />
      <StatsBanner data-id="element-6" />
      <Volumes data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <Pricing data-id="element-10" />
      <PremiumUpsell data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <PurchaseNotification data-id="element-16" />
    </div>;
}